import { Record } from 'immutable';
import ContentType from '../ContentType';

const MonthlyPriceRecord = Record({
  id: null,
  comments: null,
  created: null,
  updated: null,
  amount: null,
  month: null,
  year: null,
  expense: null,
});

class MonthlyPrice extends MonthlyPriceRecord {
  static contentType = ContentType.PAY;

  get getId() {
    return this.get('id');
  }
}

export default MonthlyPrice;
